<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.bank_accounts.form.name')"
            :is-required="true"
            :error="errors.name"
            :hint="__('settings.bank_accounts.form.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                maxlength="255"
            />
        </DFormRow>

        <template
            v-for="section in SECTIONS"
            :key="section.header"
        >
            <hr>
            <h2 class="h4">
                {{ __(section.header) }}
            </h2>
            <DFormRow
                v-for="field in section.fields"
                :key="field.name"
                :label="__(`settings.bank_accounts.form.${field.name}`)"
                :error="errors[field.name]"
                :hint="__(`settings.bank_accounts.form.${field.name}_hint`)"
            >
                <DInput
                    :id="field.name"
                    v-model="form[field.name]"
                    :name="field.name"
                    :maxlength="field.maxlength"
                />
            </DFormRow>
        </template>

        <DFormControls
            v-model="form.activity_log_comment"
            :cancel-route="route('settings.bank-accounts.index')"
            :dirty="form.isDirty"
            :show-change-reason-input="true"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

// Same fields, grouping and limits as the bank block of the brand form (SaveBrandRequest).
const SECTIONS = [
    {
        header: 'settings.bank_accounts.form.sepa_direct_debit_header',
        fields: [
            { name: 'sepa_iban', maxlength: 45 },
            { name: 'sepa_bic', maxlength: 45 },
            { name: 'sepa_bank', maxlength: 45 },
            { name: 'sepa_comment', maxlength: 45 }
        ]
    },
    {
        header: 'settings.bank_accounts.form.bank_transfer_header',
        fields: [
            { name: 'transfer_iban', maxlength: 45 },
            { name: 'transfer_bic', maxlength: 45 },
            { name: 'transfer_bank', maxlength: 45 },
            { name: 'transfer_account_number', maxlength: 20 }
        ]
    }
]

const props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    bankAccount: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    name: props.bankAccount?.name ?? '',
    ...Object.fromEntries(
        SECTIONS.flatMap(section => section.fields)
            .map(field => [field.name, props.bankAccount?.[field.name] ?? ''])
    ),
    activity_log_comment: ''
})

function submitForm () {
    emit('form-submitted', form)
}
</script>
